

























import { defineComponent, ref, computed, PropType } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { PRODUCT_PARAM_QUERIES } from '~/constants';
import { url } from '~/utils';
import { ECSchema } from '~/types/api';
import { BooleanLike } from '~/enums';

export default defineComponent({
  components: {
    AppIcon,
    AppLink,
  },
  props: {
    // EC商品詳細APIのレスポンス
    tags: {
      type: Array as PropType<Array<ECSchema<'enotecaproduct.TagShow'>>>,
      default: () => [],
    },
  },
  setup(props) {
    const isOpenKeywordTags = ref(false);
    const toggleKeywordTags = () => {
      isOpenKeywordTags.value = !isOpenKeywordTags.value;
    };

    /**
     * 表示するタグ名のリストを返す
     * 親商品に紐づくタグがある、かつ表示フラグがtrueの場合のみ表示順の昇順でそのタグ名のリストを返す
     */
    const tagNameList = computed(() => {
      if (props.tags?.length) {
        return props.tags
          .filter((tag) => tag.display_flag)
          .sort((a, b) => (a.id > b.id ? 1 : -1))
          .map((tag) => tag.name);
      }
      return [];
    });

    return { PRODUCT_PARAM_QUERIES, BooleanLike, url, toggleKeywordTags, isOpenKeywordTags, tagNameList };
  },
});
